<template>
    <div>
        <div class="card">
            <!-- START CAMPAINGS -->
            <div>
                <div class="card-header">
                    <h3
                        class="mb-0 title--click title--screen"
                        @click="
                            $router.push({
                                path: '/campaign/list',
                                query: { is_approved: 0 }
                            })
                        "
                    >
                        承認待ちキャンペーン
                    </h3>
                </div>
                <div class="card-body">
                    <TableBox
                        :list-data="listDataCampain"
                        :infor-page.sync="paginationCP"
                        :inforEditRecord="{
                            isEdit: false
                        }"
                        :is-loading="isLoading"
                        @refresh="handleRefresh"
                        @onChangePage="getListCPAwaitApproval"
                    />
                </div>
            </div>
            <!-- END CAMPAINGS -->

            <!-- START ADMIN CAMPAINGS -->
            <div>
                <div class="card-header">
                    <h3
                        class="mb-0 title--click title--screen"
                        @click="
                            $router.push({
                                path: '/campaign/list',
                                query: { person_in_charge_role: currentUser?.role?.id, is_approved: 1 }
                            })
                        "
                    >
                        管理者チーム
                    </h3>
                </div>
                <div class="card-body">
                    <TableBox
                        :list-data="listDataAdminCampain"
                        :infor-page.sync="paginationCPAdmin"
                        :inforEditRecord="{
                            isEdit: checkPermission('campaign.edit')
                        }"
                        :is-loading="isLoadingAdmin"
                        @refresh="handleRefresh"
                        @onChangePage="getListAdminCP"
                    />
                </div>
            </div>
            <!-- END ADMIN CAMPAINGS -->

            <!-- START TEAMS -->
            <div>
                <div v-for="(team, k) in listDataTeamsParent.data" :key="k">
                    <div class="card-header">
                        <h3
                            class="mb-0 title--click title--screen"
                            @click="
                                $router.push({
                                    path: '/campaign/list',
                                    query: { is_approved: 1, person_in_charge_team: team?.id }
                                })
                            "
                        >
                            {{ team.value }}
                        </h3>
                    </div>
                    <div :index="indexRenderTeam" class="card-body">
                        <TableBox
                            :list-data="listDataTeamChild[k]"
                            :infor-page.sync="paginationTeam[team.id]"
                            :inforEditRecord="{
                                isEdit: checkPermission('campaign.edit')
                            }"
                            :is-loading="isLoadingTeam[team.id]"
                            @refresh="handleRefresh"
                            @onChangePage="onHandleGetListOnceTeam(team.id, k)"
                        />
                    </div>
                </div>
            </div>
            <!-- END TEAMS -->
        </div>
    </div>
</template>

<script>
import { masterMethods, campaignMethods, authComputed, dashboardMethods } from '@/state/helpers';
import { keyMaster } from '@/config/constants';
import { campaignStatus } from '@/config/var-common';
import { checkPermission } from '@/utils/handlers';

import appConfig from '@/app.config';
import TableBox from '@/views/pages/dashboard/Tablebox/main.vue';

export default {
    page: {
        title: '管理者',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        TableBox
    },
    data() {
        return {
            //  START ADMIN CAMPAINGS
            paginationCPAdmin: {
                total: 0,
                page: 1,
                limit: 5
            },
            listDataAdminCampain: [],
            hasCP: {
                person_in_charge_role: ''
            },
            emptyAdminDataCP: false,
            isLoadingAdmin: false,
            // END ADMIN  CAMPAINGS

            //  START CAMPAINGS
            paginationCP: {
                total: 0,
                page: 1,
                limit: 5
            },
            listDataCampain: [],
            filterCP: {
                is_approved: ''
            },

            emptyDataCP: false,
            isLoading: false,
            // END  CAMPAINGS

            //  START TEAMS
            listDataTeamsParent: [],
            listDataTeamChild: [],
            paginationTeam: {},
            hasTeam: {
                person_in_charge_team: ''
            },
            isLoadingTeam: {},
            //  END TEAMS
            indexRenderTeam: 0
        };
    },
    watch: {},
    async mounted() {
        await this.getListCPAwaitApproval();
        await this.getListAdminCP();
        await this.getListTeams();
    },
    computed: {
        ...authComputed
    },
    methods: {
        ...masterMethods,
        ...campaignMethods,
        ...dashboardMethods,
        checkPermission,

        async handleRefresh() {
            await this.getListCPAwaitApproval();
            await this.getListAdminCP();
            await this.getListTeams();
        },

        goToDetail(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString(pageTable) {
            let query = [`page=${pageTable.page}`, `limit=${pageTable.limit}`, `sorts[id]=desc`];

            if (this.filterCP) {
                for (const [key, value] of Object.entries(this.filterCP)) {
                    if (key && value) query.push(`filters[${key}]=${encodeURIComponent(value)}`);
                }
            }

            if (this.hasCP) {
                for (const [key, value] of Object.entries(this.hasCP)) {
                    if (key && value) query.push(`has[${key}]=${encodeURIComponent(value)}`);
                }
            }

            if (this.hasTeam) {
                for (const [key, value] of Object.entries(this.hasTeam)) {
                    if (key && value) query.push(`has[${key}]=${encodeURIComponent(value)}`);
                }
            }

            return query.join('&');
        },

        getListCPAwaitApproval() {
            this.hasCP = null;
            this.isLoading = true;
            this.filterCP.is_approved = '0';
            this.hasTeam.person_in_charge_team = null;
            let query = this.getQueryString(this.paginationCP);
            this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query).then((data) => {
                this.isLoading = false;
                this.listDataCampain = data.data;
                this.paginationCP.total = data._metadata.total;
                this.paginationCP.page = data._metadata.page;
                this.paginationCP.limit = data._metadata.limit * 1;
            });
        },

        getListAdminCP() {
            let { role } = this.currentUser;
            this.isLoadingAdmin = true;
            this.hasCP = {
                person_in_charge_role: role?.id ?? ''
            };
            this.hasTeam.person_in_charge_team = null;
            this.filterCP.is_approved = '1';
            let query = this.getQueryString(this.paginationCPAdmin);
            this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query).then((data) => {
                this.onHanldeRenderStt(data);
                this.listDataAdminCampain = data.data;
                this.paginationCPAdmin.total = data._metadata.total;
                this.paginationCPAdmin.page = data._metadata.page;
                this.paginationCPAdmin.limit = data._metadata.limit * 1;
                this.isLoadingAdmin = false;
            });
        },

        getListTeams() {
            this.hasCP = null;
            this.filterCP.is_approved = 1;
            this.hasCP = {
                person_in_charge_role: '',
                person_in_charge_team: ''
            };
            this.listMaster(keyMaster['employee.department']).then((data) => {
                if (!data.length) return;
                const mapIdTeam = data.find((item) => item.id === 5);
                this.listDataTeamsParent = mapIdTeam;
                if (!mapIdTeam.data.length) return;
                let promises = [];
                let keyLoading = {};
                for (let i = 0; i < mapIdTeam.data.length; i++) {
                    this.paginationTeam[mapIdTeam.data[i].id] = {
                        total: 0,
                        page: 1,
                        limit: 5
                    };
                    keyLoading[mapIdTeam.data[i].id] = true;
                    this.isLoadingTeam = keyLoading;
                    this.hasTeam.person_in_charge_team = mapIdTeam.data[i].id;
                    this.listDataTeamChild[i] = [];
                    let query = this.getQueryString(this.paginationTeam[mapIdTeam.data[i].id]);
                    let promise = this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query).then((data) => {
                        this.paginationTeam[mapIdTeam.data[i].id].total = data._metadata.total;
                        this.paginationTeam[mapIdTeam.data[i].id].page = data._metadata.page;
                        this.paginationTeam[mapIdTeam.data[i].id].limit = data._metadata.limit * 1;
                        this.onHanldeRenderStt(data);
                        this.onSetTimeLoading(keyLoading, mapIdTeam.data[i].id);
                        return data.data;
                    });
                    promises.push(promise);
                }
                Promise.all(promises).then((results) => {
                    this.listDataTeamChild = results.filter((result) => result !== null);
                });
            });
        },

        async onHandleGetListOnceTeam(idTeam, kDex) {
            this.hasCP.person_in_charge_role = null;
            this.hasTeam.person_in_charge_team = idTeam;
            this.isLoadingTeam[idTeam] = true;
            try {
                let query = this.getQueryString(this.paginationTeam[idTeam]);
                const dataRes = await this.GET_LIST_CAMPAIGN_FOR_DASHBOARD(query);
                if (dataRes?.code !== 200) {
                    this.onSetTimeLoading(this.isLoadingTeam, idTeam);
                    return;
                }
                this.listDataTeamChild[kDex] = dataRes.data;
                this.paginationTeam[idTeam].total = dataRes._metadata.total;
                this.paginationTeam[idTeam].page = dataRes._metadata.page;
                this.paginationTeam[idTeam].limit = dataRes._metadata.limit * 1;
                this.onHanldeRenderStt(dataRes);
                this.onSetTimeLoading(this.isLoadingTeam, idTeam);
            } catch (error) {
                console.log('error', error);
            }
            this.indexRenderTeam++;
        },

        onHanldeRenderStt(data) {
            data?.data?.forEach((element) => {
                if (element.progress_status) {
                    element.progress_status = campaignStatus.find((itemStt) => itemStt.id === element.progress_status);
                }
            });
        },

        onSetTimeLoading(loadingType, teamId) {
            setTimeout(() => {
                loadingType[teamId] = false;
                this.indexRenderTeam++;
            }, 300);
        }
    }
};
</script>

<style lang="scss" scoped></style>
